import { useMemo } from 'react';
import useSWR from 'swr';
import { swrKeys } from '@shared/api/swr/keys';
import { mapInvoiceStatsDtoToEntity } from '@entities/invoice';
import type { InvoiceStatsDto } from '@shared/api/contracts';

export const useInvoiceStats = () => {
  const { data, error, isLoading, mutate } = useSWR<InvoiceStatsDto>(swrKeys.invoices.stats());

  const stats = useMemo(() => mapInvoiceStatsDtoToEntity(data), [data]);

  return {
    stats,
    isLoading,
    error,
    mutate,
  };
};
